module.exports = __webpack_public_path__ + "static/media/parents1.685fbc00.svg";